import styles from './AlertSectionLayout.module.scss';

type AlertSectionLayoutProps = {
  children: React.ReactNode;
  dataCy?: string;
};

const AlertSectionLayout = (props: AlertSectionLayoutProps): JSX.Element => {
  return (
    <div data-cy={props.dataCy} className={styles['alertsContainer']}>
      {props.children}
    </div>
  );
};

export default AlertSectionLayout;
